import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  setLoading: ['loading'],
  getListCatalog: ['params'],
  getListCatalogSuccess: ['listCatalog'],
});

export const ServiceRequestTypes = Types;

const ServiceRequestActions = Creators;
export default ServiceRequestActions;
